import { Dispatch, Reducer } from 'react';

export enum EActions {
    SET_SORT_HEADER,
    SET_SORT_ASC,
}

export type TActions = {
    setSortHeader: (header: string) => {
        type: EActions.SET_SORT_HEADER;
        payload: string;
    };
    setSortAsc: (asc: boolean) => {
        type: EActions.SET_SORT_ASC;
        payload: boolean;
    };
};

export type TState = {
    sortHeader: string;
    sortAsc: boolean;
};

export type TReducerActions = ReturnType<TActions[keyof TActions]>;

export type TReducer = Reducer<TState, TReducerActions>;
export type TCtx = [TState, Dispatch<TReducerActions>];
